@if ({
  isPasswordChangeActive: isPasswordChangeActive$ | async,
  isEmailChangeActive: isEmailChangeActive$ | async
}; as data) {
  <div class="section">
    @if (!data.isPasswordChangeActive) {
      <div class="section__summary">
        <div class="section__info">
          <h3 class="section__title">{{ 'label.Password' | translate }}</h3>
          <p class="section__hint">{{ 'text.PasswordRequirementsText' | translate }}</p>
        </div>

        <button type="button" class="section__toggle" [disabled]="data.isEmailChangeActive" (click)="onChangePassword()">
          {{ 'label.ChangePassword' | translate }}
        </button>
      </div>
    } @else {
      <div [formGroup]="editForm" #ngForm="ngForm">
        <h3 class="section__title section__title--with-hint">{{ 'label.ChangePassword' | translate }}</h3>
        <p class="section__hint section__hint--form">{{ 'text.PasswordRequirementsText' | translate }}</p>

        <div class="form">
          <div class="form__field">
            <span class="form__label">{{ 'label.CurrentPassword' | translate }}</span>
            <hrra-password-input class="form__password" formControlName="currentPass" [withPlaceholder]="false"></hrra-password-input>

            @if (editForm.controls['currentPass'].hasError('required') && (editForm.controls['currentPass'].touched || ngForm.submitted)) {
              <span class="form__error">{{ 'message.MandatoryField' | translate }}</span>
            }
            @if (isCurrentPasswordIncorrect$ | async) {
              <span class="form__error">{{ 'message.CurrentPasswordYouEnteredIsIncorrect' | translate }}</span>
            }
          </div>

          <div class="form__field">
            <span class="form__label">{{ 'label.NewPassword' | translate }}</span>
            <hrra-password-input class="form__password" formControlName="newPass" [withPlaceholder]="false"></hrra-password-input>

            @if (editForm.controls['newPass'].touched || ngForm.submitted) {
              @if (editForm.controls['newPass'].errors?.pattern && editForm.controls['newPass'].value?.length >= passwordMinLength) {
                <span class="form__error form__error--with-icon">
                  {{ 'message.PasswordRequirementMessage' | translate }}
                  <span class="form__error-icon" [matTooltip]="'text.PasswordRequirementsText' | translate">
                    <svg-icon src="/assets/icons/info-circle.svg"></svg-icon>
                  </span>
                </span>
              }
              @if (editForm.controls['newPass'].hasError('required')) {
                <span class="form__error">{{ 'message.MandatoryField' | translate }}</span>
              }
              @if (editForm.controls['newPass'].hasError('minlength')) {
                <span class="form__error">{{ 'message.PasswordTooShort' | translate }}</span>
              }
            }
          </div>

          <div class="form__field form__field--last">
            <span class="form__label">{{ 'label.RepeatPassword' | translate }}</span>
            <hrra-password-input class="form__password" formControlName="repeatPass" [withPlaceholder]="false"></hrra-password-input>

            @if (editForm.controls['repeatPass'].hasError('required') && (editForm.controls['repeatPass'].touched || ngForm.submitted)) {
              <span class="form__error">{{ 'message.MandatoryField' | translate }}</span>
            }
            @if ((editForm.hasError('PasswordMismatch') && (editForm.controls['repeatPass'].touched || ngForm.submitted)) || (jobseekerPasswordMismatch$ | async)) {
              <span class="form__error">{{ 'message.PasswordMismatch' | translate }}</span>
            }
          </div>

          <div class="form__buttons">
            <button type="button" class="form__save" (click)="onSave()">{{ 'label.Save' | translate }}</button>
            <button type="button" class="form__cancel" (click)="onCancel()">{{ 'label.Cancel' | translate }}</button>
          </div>
        </div>
      </div>
    }
  </div>
}
